export const Colors = {
    primary: "#26743A",
    danger: "#ff4136",
    secondary: "#F07522"
}
